module.exports = __webpack_public_path__ + "static/2-Tri-05-1371e4c3fbdcb1fcf4b2f48455ce768f.png";